export function formatDiskSize(size) {
    if (!size)
        return 0;

    var num = 1024.00; //byte

    if (size < 0) {
        let _size = 0 - (size)
        if (_size < num)
            return '-' + _size + "B";
        if (_size < Math.pow(num, 2))
            return '-' + (_size / num).toFixed(2) + "K"; //kb
        if (_size < Math.pow(num, 3))
            return '-' + (_size / Math.pow(num, 2)).toFixed(2) + "M"; //M
        if (_size < Math.pow(num, 4))
            return '-' + (_size / Math.pow(num, 3)).toFixed(2) + "G"; //G
        return '-' + (_size / Math.pow(num, 4)).toFixed(2) + "T"; //T
    } else {
        if (size < num)
            return size + "B";
        if (size < Math.pow(num, 2))
            return (size / num).toFixed(2) + "K"; //kb
        if (size < Math.pow(num, 3))
            return (size / Math.pow(num, 2)).toFixed(2) + "M"; //M
        if (size < Math.pow(num, 4))
            return (size / Math.pow(num, 3)).toFixed(2) + "G"; //G
        return (size / Math.pow(num, 4)).toFixed(2) + "T"; //T
    }
}
/**
 * 用于判断对象是不是为空对象:{},123,"",[]等都返回true {'sdf':''}返回false
 * 是空对象返回true  否则返回false
 */

export function isEmptyObject(e) {
    var t;
    for (t in e)
        return !1;
    return !0
}
/**
 * 用于判断字符串是不是为空
 */
export function isEmptyStr(obj) {
    if (typeof obj === "undefined" || obj === null || obj === "" || obj === undefined) {
        return true;
    } else {
        return false;
    }
}
export function removeNullValue(obj) {
    const newObj = {};
    if (obj && !Array.isArray(obj) && typeof obj === 'object') {
        Object.keys(obj).forEach(key => {
            const value = obj[key];
            if (value !== undefined && value !== null && value !== '' && value !== void 0) {
                newObj[key] = value;
            }
        })
    }
    return newObj;
};
export const findDataByPath = (data, path) => {
    for (let i = 0; i < data.length; i++) {
        if (data[i].path === path) {
            return data[i];
        } else if (data[i].children) {
            const result = findDataByPath(data[i].children, path);
            if (result) {
                return result;
            }
        }
    }
    return undefined;
};
export const renameTreeFields = (dataArr, option) => {
    const arr = [];
    const { title = 'title', value = 'id', children = 'childrens', num = 'deviceNum' } = option || {};
    dataArr = dataArr || [];
    dataArr.forEach(item => {
        let obj = {
            title: `${item[title]}${!isNaN(item[num]) ? '（' + item[num] + '）' : ''}`,
            value: item[value],
            key: item[value],
        };
        if (item && item[children]) {
            obj.children = renameTreeFields(item[children], { title, value, children, num });
        }
        arr.push(obj);
    });
    return arr;
}

export const pxToRem = (pxValue, rootFontSize = 1)  => {
  // 处理空值、非有效值的情况
  if (!pxValue && pxValue !== 0) {
    return '0rem';
  }

  // 统一转为字符串，方便处理
  let strValue = String(pxValue);
  
  // 提取数值部分（兼容 '100px'、'100.5px'、'-20px' 等格式）
  const numValue = parseFloat(strValue.replace(/px/g, ''));
  
  // 校验是否为有效数字
  if (isNaN(numValue)) {
    console.warn('传入的px值无效:', pxValue);
    return '0rem';
  }

  // 计算rem值并保留合适的小数位（避免无限小数）
  const remValue = (numValue / rootFontSize).toFixed(4).replace(/\.?0*$/, '');
  
  // 返回带rem单位的结果
  return `${remValue}rem`;
}



/**
 * 将HTML字符串转换为Base64编码
 * @param {string} htmlString - 要转换的HTML字符串
 * @returns {string} Base64编码后的字符串
 */
export function htmlToBase64(htmlString) {
    if (!htmlString || typeof htmlString !== 'string') {
        return '';
    }
    // 使用btoa进行Base64编码，先将字符串转换为UTF-8字节数组再编码
    return btoa(encodeURIComponent(htmlString).replace(/%([0-9A-F]{2})/g, function(match, p1) {
        return String.fromCharCode('0x' + p1);
    }));
}



/**
 * 将Base64编码解码回HTML字符串
 * @param {string} base64String - Base64编码的字符串
 * @returns {string} 解码后的HTML字符串
 */
export function base64ToHtml(base64String) {
    if (!base64String || typeof base64String !== 'string') {
        return '';
    }
    
    // 使用btoa进行Base64编码，先将字符串转换为UTF-8字节数组再编码
    try {
        // 使用atob进行Base64解码
        return decodeURIComponent(atob(base64String).split('').map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
    }
    catch (e) {
        return base64String;
    }
}